module.exports = __webpack_public_path__ + "static/media/map-8.15bc981d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/map-8.png
// module id = 590
// module chunks = 23